/** S2 (0540): Instagram im eigenen Creator-Konto. Klein gehalten, weil der Bereichsrahmen (app/layouts.tsx) es lädt. */

/** Rücksprung nach der Instagram-Anmeldung: Die Serverfunktion kehrt immer nach /creator/instagram zurück (instagram-callback) */
export const IG_RUECKSPRUNG = "tk-ig-ruecksprung";
export function merkeIgRuecksprung(pfad: string) {
  try { sessionStorage.setItem(IG_RUECKSPRUNG, pfad); } catch { /* ohne Speicher: Rückkehr ins Creator-Portal */ }
}
/** Ziel für ?ig=…&ticket=… auf /creator/instagram, wenn die Verbindung im eigenen Creator-Konto begonnen hat (einmalig) */
export function nimmIgRuecksprung(): string | null {
  try {
    const p = sessionStorage.getItem(IG_RUECKSPRUNG);
    sessionStorage.removeItem(IG_RUECKSPRUNG);
    return p && /^\/agentur\/creator\/[0-9a-f-]{36}$/.test(p) ? p : null;
  } catch {
    return null;
  }
}
